module.exports = __webpack_public_path__ + "img/202MGD.8ac63ce3.svg";